const PageRouters = {
    login:"/login"
}
export default PageRouters